import React, { useState } from "react";
import { Link } from "react-router-dom";
import { ShoppingBag } from "lucide-react";
import ProductCard from "../components/ProductCard";

import jodipiImg from "../assets/Nellore-jodipi.png"; 
import deccanImg from "../assets/Deccan-sheep.png";
import goatImg from "../assets/Crossbred-goats.png";
import lohmannImg from "../assets/Lohmann-brown.png"; 

import australorpImg from "../assets/Australorp.png"; 
import rirImg from "../assets/Rhode-island.png";

export default function Products() {
  const [cart, setCart] = useState([]);

  const breeds = [
    {
      id: 1,
      title: "Nellore Jodipi",
      image: jodipiImg,
      desc: "Live sheep distinguished by a massive frame and elite breeding standards. Known for exceptional bone density.",
      stats: { weight: "15-20kg", growth: "Fast", climate: "Arid" }
    },
    {
      id: 2,
      title: "Deccan Sheep",
      image: deccanImg,
      desc: "Hardy live sheep famous for extreme climate resilience. Ideal for large-scale commercial stall-fed setups.",
      stats: { weight: "15-18kg", growth: "Steady", climate: "Semi-Arid" }
    },
    {
      id: 3,
      title: "Crossbred Goat",
      image: goatImg,
      desc: "Live goats engineered for high-yield meat production. Combines twinning ability with aggressive weight gain.",
      stats: { weight: "10-20kg", growth: "Rapid", climate: "Tropical" }
    },
    {
      id: 4,
      title: "Australorp",
      image: australorpImg,
      desc: "The 'Grandmaster' of poultry. Famous for record-breaking egg production and a heavy, meat-rich frame.",
      stats: { yield: "300+ Eggs", type: "Dual", temperament: "Docile" }
    },
    {
      id: 5,
      title: "Lohmann Brown",
      image: lohmannImg,
      desc: "Premium live layer hens. The world leader in brown egg production, renowned for calm temperament.",
      stats: { yield: "320+ Eggs", type: "Layer", feed: "Efficient" }
    },
    {
      id: 6,
      title: "Rhode Island Red",
      image: rirImg,
      desc: "Tough, active live hens with superior disease resistance. An iconic breed for both meat and egg reliability.",
      stats: { yield: "250+ Eggs", type: "Dual", hardy: "Excellent" }
    },
  ];

  const addToCart = (breed) => {
    if (!cart.find(item => item.id === breed.id)) {
      setCart([...cart, breed]);
    }
  };

  return (
    <div className="bg-[#FDFCF8] min-h-screen py-12 relative pt-30">
      
      {cart.length > 0 && (
        <div className="fixed bottom-6 right-6 z-50 animate-bounce">
          <Link to="/contact" className="bg-[#2D5A27] text-white p-4 rounded-full shadow-2xl flex items-center gap-3 group">
            <ShoppingBag size={20} />
            <div className="bg-[#D4AF37] text-[#4B3621] w-5 h-5 flex items-center justify-center rounded-full text-[9px] font-black">
              {cart.length}
            </div>
            <span className="max-w-0 overflow-hidden group-hover:max-w-xs transition-all duration-500 text-[9px] font-black uppercase tracking-widest whitespace-nowrap px-0 group-hover:px-2">
              Request Selection Quote
            </span>
          </Link>
        </div>
      )}

      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-10">
          <span className="text-[9px] font-black uppercase tracking-[0.5em] text-[#D4AF37] block mb-2">
            Live Animal Selection
          </span>
          <h2 className="text-3xl font-black text-[#4B3621] tracking-tighter">
            Elite <span className="text-[#2D5A27]">Catalog.</span>
          </h2>
          <div className="w-12 h-1 bg-[#D4AF37] mx-auto mt-4"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {breeds.map((breed) => (
            <ProductCard
              key={breed.id}
              {...breed}
              onAddToCart={() => addToCart(breed)}
              isAdded={cart.find(item => item.id === breed.id)}
            />
          ))}
        </div>

        <div className="mt-16 text-center p-10 rounded-3xl bg-[#2D5A27] text-white relative overflow-hidden">
          <div className="relative z-10">
            <h3 className="text-xl md:text-2xl font-black mb-6 italic tracking-tighter leading-tight">
              Looking for bulk livestock procurement <br className="hidden md:block" /> or specialized breeding pairs?
            </h3>
            <Link 
              to="/contact" 
              className="inline-block bg-[#D4AF37] text-[#4B3621] px-8 py-4 rounded-xl font-black text-[10px] uppercase tracking-[0.2em] hover:bg-white transition-all shadow-lg"
            >
              Inquire About Livestock Availability
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}